import { useSites } from './useSites';

export const useAccountSites = (accountId: number | undefined): ReturnType<typeof useSites> => {
  return useSites({
    selector: (userResources) => {
      return userResources.sites
        .filter((site) => (typeof accountId === 'number' ? site.account.id === accountId : true))
        .sort(({ id: idA }, { id: idB }) => idA - idB);
    },
  });
};
